import style from "../../static/styles/css/main.css";

export default ({ hasWrapper, children }) => {
  return hasWrapper ? (
    <div className="wrapper ci-wrapper">
      {children}
      <style jsx>{style}</style>
    </div>
  ) : (
    <>{children}</>
  );
};
